function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1984(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 12.77,
    height: 1.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 0.945
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1.89,
    width: 12.77,
    height: 7.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2833333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 5.74
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.59,
    width: 12.77,
    height: 14.91,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 17.045
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 24.5,
    width: 12.77,
    height: 17.58,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 33.29
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 42.08,
    width: 12.77,
    height: 21.01,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 52.585
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 63.08,
    width: 12.77,
    height: 24.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8242857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 75.235
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 87.39,
    width: 12.77,
    height: 26.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.59625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 100.65
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 113.91,
    width: 12.77,
    height: 27.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4188888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 127.85499999999999
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 141.8,
    width: 12.77,
    height: 33.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 158.655
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 175.51,
    width: 12.77,
    height: 34.98,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 193
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 210.49,
    width: 12.77,
    height: 35.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 228.3
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 246.11,
    width: 12.77,
    height: 37.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 264.81
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 283.51,
    width: 12.77,
    height: 37.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.277
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 302.46
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 321.4,
    width: 12.77,
    height: 46.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 344.455
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 367.51,
    width: 12.77,
    height: 48.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4188888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 391.52
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 415.54,
    width: 12.77,
    height: 62.53,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 446.805
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 478.06,
    width: 12.77,
    height: 73.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.59625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 514.665
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 551.28,
    width: 12.77,
    height: 73.69,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.59625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 588.125
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 624.97,
    width: 12.77,
    height: 75.03,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1283333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.385,
    y: 662.485
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.77,
    y: 0,
    width: 23.03,
    height: 44.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 24.285,
    y: 22.195
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 0,
    width: 23.68,
    height: 44.39,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9466666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.64,
    y: 22.195
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.47,
    y: 0,
    width: 24.16,
    height: 44.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.832
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.55,
    y: 22.195
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.63,
    y: 0,
    width: 25.9,
    height: 44.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 96.58,
    y: 22.195
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.54,
    y: 0,
    width: 27.03,
    height: 44.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.055,
    y: 22.195
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.57,
    y: 0,
    width: 36.71,
    height: 44.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.078888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 154.92499999999998,
    y: 22.195
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.27,
    y: 0,
    width: 37.1,
    height: 44.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.183333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.82000000000002,
    y: 22.195
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.37,
    y: 0,
    width: 49.36,
    height: 44.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.398333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.05,
    y: 22.195
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.73,
    y: 0,
    width: 49.41,
    height: 44.39,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.932222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.435,
    y: 22.195
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.13,
    y: 0,
    width: 52.98,
    height: 44.39,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.0975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.62,
    y: 22.195
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.11,
    y: 0,
    width: 59.08,
    height: 44.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.0975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 391.65000000000003,
    y: 22.195
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.19,
    y: 0,
    width: 61.92,
    height: 44.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.398333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.15,
    y: 22.195
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.11,
    y: 0,
    width: 62.82,
    height: 44.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.54875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.52,
    y: 22.195
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 545.93,
    y: 0,
    width: 70.24,
    height: 44.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.398333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 581.05,
    y: 22.195
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 616.17,
    y: 0,
    width: 83.83,
    height: 44.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.878
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.0849999999999,
    y: 22.195
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.77,
    y: 44.39,
    width: 73.16,
    height: 54.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.614
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.349999999999994,
    y: 71.495
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.77,
    y: 98.6,
    width: 73.16,
    height: 56.32,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.386666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.349999999999994,
    y: 126.75999999999999
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.77,
    y: 154.93,
    width: 73.16,
    height: 64.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.492
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.349999999999994,
    y: 187.39000000000001
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.77,
    y: 219.85,
    width: 73.16,
    height: 66.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.616
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.349999999999994,
    y: 252.93
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.77,
    y: 286,
    width: 73.16,
    height: 66.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.121666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.349999999999994,
    y: 319.365
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.77,
    y: 352.74,
    width: 73.16,
    height: 68.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.57875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.349999999999994,
    y: 387.055
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.77,
    y: 421.37,
    width: 73.16,
    height: 81.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.632
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.349999999999994,
    y: 462.21000000000004
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.77,
    y: 503.04,
    width: 73.16,
    height: 96.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.65090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.349999999999994,
    y: 551.445
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.77,
    y: 599.85,
    width: 73.16,
    height: 100.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.627692307692308
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.349999999999994,
    y: 649.9250000000001
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.94,
    y: 44.39,
    width: 71.2,
    height: 105.41,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.53999999999999,
    y: 97.095
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 157.13,
    y: 44.39,
    width: 73.2,
    height: 105.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.200000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.73,
    y: 97.095
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.33,
    y: 44.39,
    width: 94.33,
    height: 105.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.721666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 277.495,
    y: 97.095
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.66,
    y: 44.39,
    width: 107.74,
    height: 105.41,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.058571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 378.53000000000003,
    y: 97.095
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.4,
    y: 44.39,
    width: 127.32,
    height: 105.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.712222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.05999999999995,
    y: 97.095
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.72,
    y: 44.39,
    width: 140.28,
    height: 105.41,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.108461538461539
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 629.86,
    y: 97.095
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.94,
    y: 149.8,
    width: 123.24,
    height: 120.07,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.341111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.56,
    y: 209.835
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.94,
    y: 269.87,
    width: 123.24,
    height: 132.07,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.56,
    y: 335.905
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.94,
    y: 401.93,
    width: 123.24,
    height: 143.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.802857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.56,
    y: 473.7
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.94,
    y: 545.48,
    width: 123.24,
    height: 154.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.324
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.56,
    y: 622.74
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.17,
    y: 149.8,
    width: 132.89,
    height: 186.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.98428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.615,
    y: 243.18
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.06,
    y: 149.8,
    width: 145.55,
    height: 186.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.231818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.83500000000004,
    y: 243.18
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.61,
    y: 149.8,
    width: 212.39,
    height: 186.76,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.75111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 593.8050000000001,
    y: 243.18
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.17,
    y: 336.56,
    width: 120.32,
    height: 363.44,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.05333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.33,
    y: 518.28
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.49,
    y: 336.56,
    width: 370.51,
    height: 363.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 33.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.745,
    y: 518.28
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1984);
export default __webpack_public_path__ + "static/media/1984.e3730bbe3cc0b5d89af1983a3eb69b67.svg";
export { ForwardRef as ReactComponent };